import './style.css'
import { StrictMode } from 'react'
import ReactDOM from 'react-dom/client'
import { Canvas, useThree } from '@react-three/fiber'
import Experience from './Experience.jsx'
import Interface from './components/interface/index.jsx'
import { Loader } from '@react-three/drei'
import { Leva } from 'leva'
import MobileWall from './components/interface/MobileWall.jsx'


const root = ReactDOM.createRoot(document.querySelector('#root'))

const debug = (window.location.hash === '#debug')

console.log('debug => ', debug)


root.render(
    <StrictMode>
        <MobileWall />
        <Interface className="overlay" />
         <Leva hidden={!debug} collapsed />
        <Canvas
            className='r3f'
            flat
            camera={{
                fov: 55,
                near: 0.1,
                far: 20,
                position: [0, 0, 5],
                zoom: 1
            }}
        >
            {/* <fog attach="fog" color="#ffffef" near={1} far={10}  /> */}
            <Experience />
        </Canvas>
        <Loader
            containerStyles={{ backgroundColor: '#ffffef' }}
            dataStyles={{ fontSize: '2rem', color: '#1d1d1d"' }}
            barStyles={{ background: '#ffffef' }}
            dataInterpolation={(p) => `${p.toFixed(0)}%`}
        />
    </StrictMode>
)